
import * as dev_constants from '../constants/dev_constants';

export function getErrorCategory(errCode) {
    let errCat = dev_constants.EventCatDefault;

    switch (errCode) {
        case dev_constants.EventTypeLowVoltR:
        case dev_constants.EventTypeLowVoltY:
        case dev_constants.EventTypeLowVoltB:
        case dev_constants.EventTypeHighVoltR:
        case dev_constants.EventTypeHighVoltY:
        case dev_constants.EventTypeHighVoltB:
        case dev_constants.EventTypeInputSenseFailR:
        case dev_constants.EventTypeInputSenseFailY:
        case dev_constants.EventTypeInputSenseFailB:
            errCat = dev_constants.EventCatInpFaults;
            break;
        case dev_constants.EventTypeMCBTripR:
        case dev_constants.EventTypeMCBTripY:
        case dev_constants.EventTypeMCBTripB:
        case dev_constants.EventTypeOverCurrR:
        case dev_constants.EventTypeOverCurrY:
        case dev_constants.EventTypeOverCurrB:
        case dev_constants.EventTypeLoadSenseFailR:
        case dev_constants.EventTypeLoadSenseFailY:
        case dev_constants.EventTypeLoadSenseFailB:
            errCat = dev_constants.EventCatOutFaults;
            break;
        default:
            errCat = dev_constants.EventCatDefault;
            break;
    }

    return errCat;
}

export function isErrorGrpAlreadyExists(deviceData, errorCodes) {
    if (deviceData.errors !== undefined) {
        for (let i = 0; i < errorCodes.length; i++) {
            let errCode = errorCodes[i];
            const found = deviceData.errors.find(element => element === errCode);
            if (found === errCode) {
                return true;
            }
        }
    }

    return false;
}

export function getErrorGrpId(errorCode) {
    for (let i = 0; i < dev_constants.errGrpInfoArray.length; i++) {
        let grpInfo = dev_constants.errGrpInfoArray[i];
        const found = grpInfo.errCodes.find(element => element === errorCode);
        if (found === errorCode) {
            return grpInfo.grpId;
        }
    }
    return -1;
}

export function showDeviceAsOff(deviceData) {
    if (deviceData.errors !== undefined) {
        for (let i = 0; i < deviceData.errors.length; i++) {
            if (treatErrorAsOff(deviceData.errors[i], deviceData)) {
                return true;
            }
        }    
    }
    return false;
}

function treatErrorAsOff(errCode, deviceData) {
    switch (errCode) {
        case dev_constants.EventTypeLowBattery:
        case dev_constants.EventTypeManualMode:
        case dev_constants.EventTypeBypassMode:
        case dev_constants.EventTypeDoorOpen:
        case dev_constants.EventTypeDoorOpenContinous:
        case dev_constants.EventTypeTheft:
            break;
        case dev_constants.EventTypeLampOff:
            if (deviceData.lmp_cnt === deviceData.lmp_off_cnt) {
                return true;
            }
            break;
        default:
            return true;
    }
    return false;
}

function arrayDiff(array1, array2) {
    let arr1 = array1 || [];
    let arr2 = array2 || [];

    let difference1 = arr1.filter(x => !arr2.includes(x));
    let difference2 = arr2.filter(x => !arr1.includes(x));

    return [...difference1, ...difference2];
}

export const isInsideSchedule = (schedule) => {
    if (!schedule) {
        return false;
    }

    let slotTimes = [];
    const info = schedule.scheduleInfo || schedule;

    if (info.slot_times && Array.isArray(info.slot_times)) {
        slotTimes = info.slot_times;
    } else if (info.on_time && info.off_time) {
        slotTimes = [{
            on_time: info.on_time,
            off_time: info.off_time
        }];
    } else {
        return false;
    }
    
    const now = new Date();
    const currentHrs = now.getHours();
    const currentMins = now.getMinutes();
    const currentTotalMins = currentHrs * 60 + currentMins;
    // console.log(`isInsideSchedule -> Current local time: ${currentHrs}:${currentMins} (${currentTotalMins} mins)`);

    for (const slot of slotTimes) {
        const onTime = slot.on_time;
        const offTime = slot.off_time;
        
        if (!onTime || !offTime) continue;
        
        const onTotalMins = onTime.hrs * 60 + onTime.mins;
        const offTotalMins = offTime.hrs * 60 + offTime.mins;
        // console.log(`isInsideSchedule -> checking slot: ON ${onTime.hrs}:${onTime.mins} (${onTotalMins}), OFF ${offTime.hrs}:${offTime.mins} (${offTotalMins})`);

        if (onTotalMins < offTotalMins) {
            if (currentTotalMins >= onTotalMins && currentTotalMins < offTotalMins) {
                // console.log("isInsideSchedule -> true (same day)");
                return true;
            }
        } else if (onTotalMins > offTotalMins) {
            if (currentTotalMins >= onTotalMins || currentTotalMins < offTotalMins) {
                // console.log("isInsideSchedule -> true (overnight)");
                return true;
            }
        } else {
            // If onTime == offTime, usually means not configured or always on/off depending on logic
        }
    }
    // console.log("isInsideSchedule -> false (not matching any slot)");
    return false;
};

export function arraySymmetricDiff(a1, a2) {
    return {
        removed: arrayDiff(a1, a2),
        added: arrayDiff(a2, a1)
    };
}

export function clearCounts(countsObject, devMap) {
    console.log("clearing all counts...");
    countsObject.slcCnt = 0;
    countsObject.slcOnCnt = 0;
    countsObject.slcOffCnt = 0;
    countsObject.slcErrCnt = 0;

    countsObject.lmpCnt = 0;
    countsObject.lmpOnCnt = 0;
    countsObject.lmpOffCnt = 0;

    countsObject.modes.autoCnt = 0;
    countsObject.modes.manCnt = 0;
    countsObject.modes.bypCnt = 0;

    countsObject.inpFaults.lvCnt = 0;
    countsObject.inpFaults.hvCnt = 0;
    countsObject.inpFaults.pfCnt = 0;
    countsObject.inpFaults.isofCnt = 0;

    countsObject.outFaults.tripCnt = 0;
    countsObject.outFaults.hcCnt = 0;
    countsObject.outFaults.cfCnt = 0;

    countsObject.othFaults.emfCnt = 0;
    countsObject.othFaults.doCnt = 0;
    countsObject.othFaults.lbCnt = 0;
    countsObject.othFaults.inaCnt = 0;

    countsObject.errGrpCounts.fill(0);

    if (devMap !== undefined) {
        devMap.clear();
    }
}
